module.exports = __webpack_public_path__ + "static/img/11.79173be.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/sp/11.png
// module id = tA6H
// module chunks = 0